export const debug = window.localStorage.getItem('debug') === 'true'
